import React from 'react'

/* package */
import { SectionWrappList } from '../../lib-atomic-section'
/* package */

/* container */
import LayoutContainer from '../../app-layout-container/default'
/* container */

/* form */
import Content from '../layout/content'
/* form */

const index = (props) => {
  return (
    <LayoutContainer.LayoutList {...props}>
      <SectionWrappList {...props}>
        <Content {...props} />
      </SectionWrappList>
    </LayoutContainer.LayoutList>
  )
}

export default index
